import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customers = async (data: CustomersReqT) => {
  const {
    categoryId,
    pageParam,
    name,
    phone,
    cityId,
    status,
    birthday,
    passed_cheque_amount,
    popular_categories,
    frindship_id,
  } = data;

  const qs = `?category_id=${categoryId ?? ""}&page=${pageParam ?? 1}&name=${
    name ?? ""
  }&status=${status ?? ""}&phone=${phone ?? ""}&cityId=${
    cityId ?? ""
  }&popular_categories=${popular_categories ?? ""}&birthday=${
    birthday ?? ""
  }&passed_cheque_amount=${passed_cheque_amount ?? ""}&frindship_id=${
    frindship_id ?? ""
  }`;

  return axios.get(Routes.CUSTOMERS + qs);
};

export const useCustomers = (params: CustomersReqT) => {
  const {
    categoryId,
    name,
    status,
    birthday,
    passed_cheque_amount,
    cityId,
    popular_categories,
    phone,
    frindship_id,
  } = params;
  return useInfiniteQuery({
    queryKey: [
      Keys.CUSTOMERS_QRY,
      categoryId,
      name,
      status,
      birthday,
      passed_cheque_amount,
      cityId,
      phone,
      popular_categories,
      frindship_id,
    ],
    queryFn: ({ pageParam = 1 }) => customers({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
